// SECOND wokring JS

document.addEventListener('DOMContentLoaded', function () {

  const megaMenus = document.querySelectorAll('.custom-mega-menu');
  if (!megaMenus.length) return;

  const headerNav = document.querySelector('.bdb-header__nav');
  if (!headerNav) return;

  const subTitleEl = document.getElementById('mega-sub-title');
  const prodTitleEl = document.getElementById('mega-products-title');

  const toHandle = (text) =>
    text.toLowerCase().trim().replace(/\s+/g, '-');

  const hideAllMegaMenus = () => {
    megaMenus.forEach(menu => menu.classList.remove('is-active'));
  };

  const isDesktop = () =>
    window.matchMedia('(min-width: 990px)').matches;

  // ================= Header Menu Hover =================
  headerNav.querySelectorAll('.bdb-header__nav-link').forEach(link => {

    const label = link.querySelector('.bdb-header__nav-label');
    if (!label) return;

    const handle = toHandle(label.textContent);
    const relatedMegaMenu = document.querySelector(
      `.custom-mega-menu[data-menu="${handle}"]`
    );

    if (!relatedMegaMenu) return;

    link.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      hideAllMegaMenus();
      relatedMegaMenu.classList.add('is-active');
    });
  });





// worked on console

//       document.addEventListener('mouseover', function(e){

//   const menuItem = e.target.closest(
//     '.header__primary-nav-item[data-title="Shop By Products"]'
//   );

//   if (!menuItem) return;

//   console.log('hover works');

//   document
//     .querySelector('.custom-mega-menu[data-menu="shop-by-products"]')
//     ?.classList.add('is-active');

// });

// document.addEventListener('mouseout', function(e){

//   const menuItem = e.target.closest(
//     '.header__primary-nav-item[data-title="Shop By Products"]'
//   );

//   if (!menuItem) return;

//   document
//     .querySelector('.custom-mega-menu[data-menu="shop-by-products"]')
//     ?.classList.remove('is-active');

// });






                  // ================= Header Menu Hover =================
                //     headerNav.addEventListener('mouseover', function (e) {

                //       if (!isDesktop()) return;

                //       const item = e.target.closest('.header__primary-nav-item');
                //       if (!item) return;

                //       const title = item.dataset.title;

                //       console.log('hovered:', title);

                //       hideAllMegaMenus();

                //       if (!title) return;

                //       const handle = toHandle(title);

                //       const relatedMegaMenu = document.querySelector(
                //         `.custom-mega-menu[data-menu="${handle}"]`
                //       );

                //       console.log('handle:', handle);
                //       console.log('menu found:', relatedMegaMenu);

                //       if (relatedMegaMenu) {
                //         relatedMegaMenu.classList.add('is-active');
                //       }

                //     });

                //     // close mega menu when leaving nav
                // headerNav.addEventListener('mouseleave', () => {
                //   hideAllMegaMenus();
                // });




  // new code to fix hover nav item issue
  // CLOSE mega menu when hovering another nav item
headerNav.querySelectorAll('.bdb-header__nav-item').forEach(item => {

  item.addEventListener('mouseenter', () => {

    const link = item.querySelector('.bdb-header__nav-link');
    if (!link) return;

    const label = link.querySelector('.bdb-header__nav-label');
    if (!label) {
      hideAllMegaMenus();
      return;
    }

    const handle = toHandle(label.textContent);
    const relatedMegaMenu = document.querySelector(
      `.custom-mega-menu[data-menu="${handle}"]`
    );

    // If this nav item has NO mega menu → close all
    if (!relatedMegaMenu) {
      hideAllMegaMenus();
    }

  });

});




  megaMenus.forEach(menu => {
    menu.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      menu.classList.add('is-active');
    });

    menu.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      menu.classList.remove('is-active');
    });
  });

  // ================= Column 1 → Column 2 → Column 3 =================
  document.querySelectorAll('.mega-main-item').forEach(mainItem => {

    // HOVER
    mainItem.addEventListener('mouseenter', () => {
      const handle = mainItem.dataset.handle;
      if (!handle) return;

      document.querySelectorAll('.mega-main-item')
        .forEach(i => i.classList.remove('active'));
      mainItem.classList.add('active');

      document.querySelectorAll('.mega-sub-collections')
        .forEach(ul => ul.classList.remove('active'));

      const relatedSub = document.querySelector(
        `.mega-sub-collections[data-parent="${handle}"]`
      );

      if (!relatedSub) return;
      relatedSub.classList.add('active');

      if (subTitleEl) subTitleEl.textContent = mainItem.textContent;

      // old code
      // const firstSub = relatedSub.querySelector('.mega-sub-item');
      // if (!firstSub) return;

      // activateSubItem(firstSub);

      // new code for no-subcategory product's showing on third column
        const firstSub = relatedSub.querySelector('.mega-sub-item');

        // REMOVE previous products
        document.querySelectorAll('.mega-products')
          .forEach(p => p.classList.remove('active'));

        // If subcategory exists → normal flow
        if (firstSub) {
          activateSubItem(firstSub);
        } else {

          // No subcategory → show main collection products
          const mainProducts = document.querySelector(
            `.mega-products[data-products="${handle}"]`
          );

          if (mainProducts) {
            mainProducts.classList.add('active');
          }

          if (prodTitleEl) {
            prodTitleEl.textContent = mainItem.textContent;
          }
        }


    });

    // CLICK → navigate
    mainItem.addEventListener('click', () => {
      const url = mainItem.dataset.url;
      if (url) window.location.href = url;
    });
  });

  // ================= Column 2 → Column 3 =================
  document.querySelectorAll('.mega-sub-item').forEach(subItem => {

    // HOVER
    subItem.addEventListener('mouseenter', () => {
      activateSubItem(subItem);
    });

    // CLICK → navigate
    subItem.addEventListener('click', () => {
      const url = subItem.dataset.url;
      if (url) window.location.href = url;
    });
  });

  // ================= Helper =================
  function activateSubItem(subItem) {
    const handle = subItem.dataset.subHandle;
    if (!handle) return;

    document.querySelectorAll('.mega-sub-item')
      .forEach(i => i.classList.remove('active'));
    subItem.classList.add('active');

    document.querySelectorAll('.mega-products')
      .forEach(p => p.classList.remove('active'));

    const relatedProducts = document.querySelector(
      `.mega-products[data-products="${handle}"]`
    );

    if (relatedProducts) relatedProducts.classList.add('active');
    if (prodTitleEl) prodTitleEl.textContent = subItem.textContent;
  }

  // ================= Default Load =================
  const firstActiveSubList = document.querySelector('.mega-sub-collections.active');
  if (firstActiveSubList) {
    const firstSub = firstActiveSubList.querySelector('.mega-sub-item');
    if (firstSub) activateSubItem(firstSub);
  }

// // hide megamenu if not on hader
//   document.querySelector('.bdb-header').addEventListener('mouseleave', () => {
//     hideAllMegaMenus();
//   });
});
